import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <Container>
        <Row>
          <Col md={4} className="mb-3 mb-md-0">
            <h5 className="footer-brand">YouSureAboutThat.ai</h5>
        <p className="footer-description">
  Validating facts and checking links for accuracy with AI-powered precision.
            </p>
          </Col>
   <Col md={4} className="mb-3 mb-md-0">
            <h6 className="footer-heading">Quick Links</h6>
        <ul className="footer-links">
     <li><a href="/">Home</a></li>
       <li><a href="/validator">Validator</a></li>
  {/* Prepared for future pages */}
              {/* <li><a href="/about">About</a></li> */}
    {/* <li><a href="/privacy">Privacy Policy</a></li> */}
    </ul>
     </Col>
   <Col md={4}>
            <h6 className="footer-heading">Contact</h6>
            <p className="footer-text">
   Questions or feedback?<br />
         <a href="mailto:info@yousureabouthat.ai" className="footer-link">
                info@yousureabouthat.ai
  </a>
    </p>
   </Col>
</Row>
        <hr className="footer-divider" />
        <Row>
    <Col className="text-center">
            <p className="footer-copyright">
         � {currentYear} YouSureAboutThat.ai. All rights reserved.
         </p>
  </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
